import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { cacheKeys } from '../constants/storageKeys';
import styles from './UserScore.module.less';
import { imgLocalUrl } from '../utils/utils';
import { logging } from '../actions/log';
import { addScoreForStore } from '../actions/comment';
import { SHOP_ORDER_LIST_65 } from '../config';
import { hasClass, removeClass, addClass, changeClass } from '../utils/utils';
import { add } from 'lodash-es';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default function User() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const scoreNum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const userScoreBoxRef = useRef(null);
  const userScoreRef = useRef(null);
  const userRef = useRef(null);
  const scoreRef = useRef(null);
  const resultRef = useRef(null);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'UserScore',
        label: '',
        param2: {
          source: `UserScore`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  const judgeDom = useCallback(() => {
    return (
      userScoreRef &&
      userScoreRef.current &&
      userRef &&
      userRef.current &&
      scoreRef &&
      scoreRef.current &&
      resultRef &&
      resultRef.current
    );
  }, [userScoreRef, userRef, scoreRef, resultRef]);

  const onMouseOver = useCallback(
    e => {
      if (judgeDom()) {
        const userScoreDom = userScoreRef.current;
        const userDom = userRef.current;
        const scoreDom = scoreRef.current;
        const resultDom = resultRef.current;
        if (!hasClass(resultDom, styles.to_show)) {
          if (!hasClass(userDom, styles.to_hiddle) && !hasClass(scoreDom, styles.to_show)) {
            dispatch(
              logging({
                category: 'C',
                action: 'UserScore_Hover',
                label: '',
                param2: {
                  source: `UserScore`,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                },
              }),
            );
          }
          changeClass(userScoreDom, styles.user_score_longer, styles.user_score_short);
          changeClass(userDom, styles.to_hiddle, styles.to_show);
          changeClass(scoreDom, styles.to_show, styles.to_hiddle);
        }
      }
    },
    [logInfoData, userScoreRef, userRef, scoreRef, resultRef],
  );

  const onMouseLeave = useCallback(
    e => {
      if (judgeDom()) {
        const userScoreDom = userScoreRef.current;
        const userDom = userRef.current;
        const scoreDom = scoreRef.current;
        const resultDom = resultRef.current;
        if (!hasClass(resultDom, styles.to_show)) {
          changeClass(userScoreDom, styles.user_score_short, styles.user_score_longer);
          changeClass(userDom, styles.to_show, styles.to_hiddle);
          changeClass(scoreDom, styles.to_hiddle, styles.to_show);
        }
      }
    },
    [userScoreRef, userRef, scoreRef, resultRef],
  );

  const onScoreClick = useCallback(
    score => {
      if (judgeDom()) {
        dispatch(
          logging({
            category: 'C',
            action: 'UserScore_CheckNum',
            label: '',
            param2: {
              source: `UserScore`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              score,
            },
          }),
        );
        const boxDom = userScoreBoxRef.current;
        const userScoreDom = userScoreRef.current;
        const userDom = userRef.current;
        const scoreDom = scoreRef.current;
        const resultDom = resultRef.current;
        changeClass(userDom, styles.to_hiddle, styles.to_show);
        changeClass(scoreDom, styles.to_hiddle, styles.to_show);
        changeClass(resultDom, styles.to_show, styles.to_hiddle);

        dispatch(addScoreForStore({ score }));
        localStorage.setItem(cacheKeys.USER_SCORE_VISIBLE, score);

        setTimeout(() => {
          addClass(boxDom, styles.to_close);
          setTimeout(() => {
            boxDom.style.display = 'none';
          }, 500);
        }, 2500);
      }
    },
    [logInfoData, userScoreBoxRef, userScoreRef, userRef, scoreRef, resultRef],
  );

  const onUserScoreClose = useCallback(() => {
    if (judgeDom()) {
      dispatch(
        logging({
          category: 'C',
          action: 'UserScore_Close',
          label: '',
          param2: {
            source: `UserScore`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      const boxDom = userScoreBoxRef.current;
      addClass(boxDom, styles.to_close);
      setTimeout(() => {
        boxDom.style.display = 'none';
      }, 500);
    }
    localStorage.setItem(cacheKeys.USER_SCORE_VISIBLE, '0');
  }, [logInfoData, userScoreBoxRef]);

  return (
    <div className={`${styles.user_score_box}`} ref={userScoreBoxRef}>
      <div
        className="user_score"
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        ref={userScoreRef}
      >
        <div className="iconfont icon-close_small close_small" onClick={onUserScoreClose}></div>
        <div className="user" ref={userRef}>
          <div className={`user_img ${styles.img_rotate}`}></div>
          <div className="user_text">小调查</div>
        </div>
        <div className="score" ref={scoreRef}>
          <div className="score_text">你愿意向朋友推荐联想应用商店吗？</div>
          <div className="score_box">
            {scoreNum.map((score, i) => (
              <div
                className="score_item"
                key={i}
                onClick={() => {
                  onScoreClick(score);
                }}
              >
                {score}
              </div>
            ))}
          </div>
        </div>
        <div className="score_result" ref={resultRef}>
          <div className={`score_result_img ${styles.img_rotate}`}></div>
          <div className="score_result_text">提交成功，感谢您的参与！</div>
        </div>
      </div>
    </div>
  );
}
